import type { HttpGetBlob } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { DownloadSignatureRequestAuditLog } from '@/shared/domain'

export class SupabaseDownloadSignatureRequestAuditLogRepository {
  constructor(private readonly http: HttpGetBlob) {}

  execute: DownloadSignatureRequestAuditLog = async ({ id }) => {
    try {
      return await this.http.getBlob({
        url: `/signature-requests/${encodeURIComponent(id)}/audit-log`,
      })
    } catch (error) {
      mapServerError(error)
    }
  }
}
